export const ru = {
    choose_for: 'Выбрать за',
    chose_for: 'Выбран за',
    tariff: 'Тариф',
    option: 'Вариант {number}',
};
